import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { influencerData, images } from '../../data/mock';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden bg-[#0A0A0A]">
      {/* Background Image with Zoom Animation */}
      <div
        className="absolute inset-0 transition-transform duration-[20s] ease-out"
        style={{
          transform: isVisible ? 'scale(1.1)' : 'scale(1)',
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${images.hero})`,
          }}
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/80 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <div className="max-w-2xl">
            {/* Eyebrow */}
            <p
              className={`text-[#D4AF37] text-xs tracking-[0.4em] mb-6 transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: '300ms' }}
            >
              ELITE FITNESS CREATOR
            </p>

            {/* Main Headline */}
            <h1
              className={`font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '500ms' }}
            >
              Where Performance
              <br />
              Meets{' '}
              <span className="text-[#D4AF37] italic">Prestige</span>
            </h1>

            {/* Subheadline */}
            <p
              className={`text-[#A1A1AA] text-lg md:text-xl leading-relaxed mb-10 transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '700ms' }}
            >
              Transforming brands into cultural moments through authentic storytelling
              and an audience of {influencerData.followers} engaged followers.
            </p>

            {/* CTA Button */}
            <div
              className={`transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '900ms' }}
            >
              <button
                onClick={scrollToAbout}
                className="group px-8 py-4 border border-[#D4AF37] text-[#D4AF37] text-sm tracking-[0.2em] hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-all duration-500 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:scale-105"
              >
                DISCOVER MORE
              </button>
            </div>

            {/* Stats Row */}
            <div
              className={`flex gap-12 mt-16 pt-8 border-t border-white/10 transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '1100ms' }}
            >
              <div>
                <p className="text-[#D4AF37] text-2xl md:text-3xl font-light">{influencerData.followers}</p>
                <p className="text-[#A1A1AA] text-xs tracking-[0.2em] mt-1">FOLLOWERS</p>
              </div>
              <div>
                <p className="text-[#D4AF37] text-2xl md:text-3xl font-light">{influencerData.engagementRate}%</p>
                <p className="text-[#A1A1AA] text-xs tracking-[0.2em] mt-1">ENGAGEMENT</p>
              </div>
              <div>
                <p className="text-[#D4AF37] text-2xl md:text-3xl font-light">{influencerData.usaAudience}%</p>
                <p className="text-[#A1A1AA] text-xs tracking-[0.2em] mt-1">USA AUDIENCE</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className={`absolute bottom-8 left-1/2 -translate-x-1/2 text-[#A1A1AA] hover:text-[#D4AF37] transition-all duration-500 animate-bounce ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ transitionDelay: '1300ms' }}
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
